export const SECTION_CATEGORY = 'onboarding';
export const SECTION_FAMILY = 'banking';
export const SECTION_NAME = 'userOnboarding';
export const SERVICE_TYPE = 'onboarding';
export const PROCESS_TYPE = 'onboarding';

export const INTERACTION_TYPES = {
    FUNNEL: 'funnel',
    PAGE: 'page',
};
